"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectReadReceiptOption_1 = require("../actions/selectReadReceiptOption");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
var owa_session_store_1 = require("owa-session-store");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var ReadReceiptsFull = /** @class */ (function (_super) {
    tslib_1.__extends(ReadReceiptsFull, _super);
    function ReadReceiptsFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectReadReceiptOption_1.default(option.key);
        };
        return _this;
    }
    ReadReceiptsFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var selectedKey = owa_options_core_1.getFallbackValueIfNull(optionStore.readReceiptResponse, userOptions.ReadReceipt);
        var choices = [
            {
                key: 'DoNotAutomaticallySend',
                text: owa_options_strings_1.default.options_mail_ReadReceiptPrompt,
            },
            {
                key: 'AlwaysSend',
                text: owa_options_strings_1.default.options_mail_ReadReceiptAlways,
            },
            {
                key: 'NeverSend',
                text: owa_options_strings_1.default.options_mail_ReadReceiptNever,
            },
        ];
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: selectedKey, options: choices, onChange: this.onChange, label: owa_options_strings_1.default.options_mail_ReadReceiptTitle }));
    };
    ReadReceiptsFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], ReadReceiptsFull);
    return ReadReceiptsFull;
}(React.Component));
exports.default = ReadReceiptsFull;
//# sourceMappingURL=ReadReceiptsFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-read-receipts-option/lib/components/ReadReceiptsFull.js
// module id = 5061
// module chunks = 2